import * as types from "./actionTypes";
import { getLimitedFilteredInstrumentList } from "../../../utils/helpers/fetching";

const FETCH_FILTERED_INSTRUMENTS_ERROR = "Failed to load instruments";
const UNKNOWN_ERROR = "Unknown error";

export const setLoadingInstruments = (loading, requestId = null) => ({
  type: types.SET_LOADING_INSTRUMENTS,
  payload: { loading, requestId },
});

export const loadFilteredInstruments = (instruments, requestId = null) => ({
  type: types.LOAD_FILTERED_INSTRUMENTS,
  payload: { instruments, requestId },
});

export const setInstrumentsError = (error, requestId = null) => ({
  type: types.SET_INSTRUMENTS_ERROR,
  payload: { error, requestId },
});

let filteredInstrumentsRequestCounter = 0;

export const fetchFilteredInstruments = ({ client, user, filters = {} }) => {
  return async (dispatch) => {
    const requestId = ++filteredInstrumentsRequestCounter;
    dispatch(setLoadingInstruments(true, requestId));

    try {
      const instruments = await getLimitedFilteredInstrumentList({
        client,
        user,
        filters,
      });

      if (instruments && !instruments.error) {
        dispatch(loadFilteredInstruments(instruments, requestId));
      } else {
        dispatch(setInstrumentsError(instruments?.error || FETCH_FILTERED_INSTRUMENTS_ERROR, requestId));
      }
    } catch (error) {
      console.error("Error fetching filtered instruments:", error);
      dispatch(setInstrumentsError(error.message || UNKNOWN_ERROR, requestId));
    } finally {
      dispatch(setLoadingInstruments(false, requestId));
    }
  };
};
